export class PayInPayOutEnum {
    static PAYIN = "Pay In";
    static PAYOUT = "Pay Out";
  }